// extracted by mini-css-extract-plugin
export default {"bannersList":"styles_bannersList__+2BR0"};